<template>
    <div class="find-a-doctor-filters">
        <div class="find-a-doctor-filters__filters" ref="filters">
            <button class="icon -close find-a-doctor-filters__filters-close" @click="$emit('close')">
                <span class="sr-only">Close</span>
            </button>
            <filter-section header="Your Search">
                <search-filter
                    label="Search by Name"
                    type="personnel"
                    placeholder="Search by Name"
                    :filters="{ researcher: 'true' }"
                    v-model="name"
                />
            </filter-section>
            <button class="button find-a-doctor-filters__search-button" @click="$emit('search')">Search</button>
            <button class="button -link -spaceless" @click="resetFilters">Clear Filters</button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions, mapState } from 'vuex';
import $ from 'wee-dom';
import $events from 'wee-events';
import $mediator from 'wee-mediator';
import $screen from 'wee-screen';
import { _win } from 'core/variables';
import FilterSection from '../../find-a-doctor/filter-section/index.vue';
import SearchFilter from '../../find-a-doctor/search-filter/index.vue';
import ElementSelectFilter from '../../find-a-doctor/element-select-filter/index.vue';
import Tabbable from '../../../scripts/tabbable.js';

export default {
    components: {
        FilterSection,
        SearchFilter,
        ElementSelectFilter,
    },
    props: {
        active: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {
        $events.on(_win, `resize.${this._uid}`, () => {
            Vue.set(this, 'screenSize', $screen.size());
        });
    },
    destroyed() {
        $events.off(null, `.${this._uid}`);
    },
    methods: {
        ...mapActions(['setFilter', 'resetFilters']),
        updateFilter(filter, value) {
            this.setFilter({ filter, value });
        },
    },
    watch: {
        active(value) {
            if (value && this.screenSize < 4) {
                this.tabbable = new Tabbable({
                    el: this.$refs.filters,
                    callback: () => {
                        this.tabbable.$firstEl[0].focus();
                    },
                });
            } else {
                this.tabbable = null;
            }
        },
    },
    computed: {
        specialty: {
            get() {
                return this.$store.state.filters.specialty  ;
            },
            set(value) {
                this.$store.commit('setFilter', {
                    filter: 'specialty',
                    value
                });
            },
        },
        name: {
            get() {
                return this.$store.state.filters.name;
            },
            set(value) {
                this.$store.commit('setFilter', {
                    filter: 'name',
                    value
                });
            },
        },
    },
    data: () => ({
        screenSize: $screen.size(),
        tabbable: null,
    }),
};
</script>
